import { Button } from 'antd';
import { useContext } from 'react';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';
import type { GiftCard } from 'app/typings/giftCard';
import { GiftCardType } from 'app/typings/giftCard';

import { Line } from '../Line/Line';

type Props = {
  giftCard: GiftCard;
  setIsRefundModalVisible: (isVisible: boolean) => void;
};

export const Payment = ({ giftCard, setIsRefundModalVisible }: Props) => {
  const { cardInfo, status, giftCardType } = giftCard;
  const { currencyFormatter } = useContext(CurrencyContext);

  const isActiveAndNotRefundable =
    status === 'active' &&
    ![
      GiftCardType.Voucher,
      GiftCardType.Incentive,
      GiftCardType.Internal,
      GiftCardType.Manual,
    ].includes(giftCardType);

  return (
    <div className="bloc">
      <div className="title-with-button2">
        <div className="label">Payment</div>
        {isActiveAndNotRefundable && (
          <Button
            className="button"
            onClick={() => setIsRefundModalVisible(true)}
          >
            Refund
          </Button>
        )}
      </div>
      <div className="generic-content">
        {cardInfo && (
          <Line title="Card info" value={`•••• ${cardInfo.last4}`} />
        )}
        {giftCard.valueType === 'FIX' && (
          <Line
            title="Charged amount"
            value={currencyFormatter(giftCard.initialValue)}
          />
        )}
      </div>
    </div>
  );
};
